var InitiateSimpleDataTable = function() {
    return {
        init: function() {
            //Datatable Initiating
            var oTable = $('#simpledatatable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
                "iDisplayLength": 5,
                "oTableTools": {
                    "aButtons": [
                        "copy", "csv", "xls", "pdf", "print"
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                },
                "aoColumns": [
                    {
                        "bSortable": false,
                        "width": '45px'
                    },
                    null,
                    { "bSortable": false },
                    null,
                    { "bSortable": false }
                ],
                
                "aaSorting": []
            });

            //Check All Functionality
            $('#simpledatatable thead th input[type=checkbox]').change(function() {
                var set = $("#simpledatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#simpledatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });

        }

    };

}();
var InitiateEditableDataTable = function() {
    return {
        init: function() {
            //Datatable Initiating
            var oTable = $('#editabledatatable').dataTable({
                "aLengthMenu": [
                    [5, 15, 20, 100, -1],
                    [5, 15, 20, 100, "All"]
                ],
                "iDisplayLength": 5,
                "sPaginationType": "bootstrap",
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                },
                "aoColumns": [
                    null,
                    null,
                    null,
                    null,
                    { "bSortable": false }
                ]
            });

            var isEditing = null;

            //Add New Row
            $('#editabledatatable_new').click(function(e) {
                e.preventDefault();
                var aiNew = oTable.fnAddData([
                    '', '', '', '',
                    '<a href="#" class="btn btn-success btn-xs save"><i class="fa fa-edit"></i> Save</a> <a href="#" class="btn btn-warning btn-xs cancel" data-mode="new"><i class="fa fa-times"></i> Cancel</a>'
                ]);
                var nRow = oTable.fnGetNodes(aiNew[0]);
                editAddedRow(oTable, nRow);
                isEditing = nRow;
            });

            //Delete an Existing Row
            $('#editabledatatable').on("click", 'a.delete', function(e) {
                e.preventDefault();

                if (confirm("Are You Sure To Delete This Row?") == false) {
                    return;
                }

                var nRow = $(this).parents('tr')[0];
                oTable.fnDeleteRow(nRow);
                alert("Row Has Been Deleted!");
            });

            //Cancel Editing or Adding a Row
            $('#editabledatatable').on("click", 'a.cancel', function(e) {
                e.preventDefault();
                if ($(this).attr("data-mode") == "new") {
                    var nRow = $(this).parents('tr')[0];
                    oTable.fnDeleteRow(nRow);
                    isEditing = null;
                } else {
                    restoreRow(oTable, isEditing);
                    isEditing = null;
                }
            });

            //Edit A Row
            $('#editabledatatable').on("click", 'a.edit', function(e) {
                e.preventDefault();

                var nRow = $(this).parents('tr')[0];

                if (isEditing !== null && isEditing != nRow) {
                    restoreRow(oTable, isEditing);
                    editRow(oTable, nRow);
                    isEditing = nRow;
                } else {
                    editRow(oTable, nRow);
                    isEditing = nRow;
                }
            });

            //Save an Editing Row
            $('#editabledatatable').on("click", 'a.save', function(e) {
                e.preventDefault();
                if (this.innerHTML.indexOf("Save") >= 0) {
                    saveRow(oTable, isEditing);
                    isEditing = null;
                    //Some Code to Highlight Updated Row
                }
            });


            function restoreRow(oTable, nRow) {
                var aData = oTable.fnGetData(nRow);
                var jqTds = $('>td', nRow);

                for (var i = 0, iLen = jqTds.length; i < iLen; i++) {
                    oTable.fnUpdate(aData[i], nRow, i, false);
                }

                oTable.fnDraw();
            }

            function editRow(oTable, nRow) {
                var aData = oTable.fnGetData(nRow);
                var jqTds = $('>td', nRow);
                jqTds[0].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[0] + '">';
                jqTds[1].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[1] + '">';
                jqTds[2].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[2] + '">';
                jqTds[3].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[3] + '">';
                jqTds[4].innerHTML = '<a href="#" class="btn btn-success btn-xs save"><i class="fa fa-save"></i> Save</a> <a href="#" class="btn btn-warning btn-xs cancel"><i class="fa fa-times"></i> Cancel</a>';
            }

            function editAddedRow(oTable, nRow) {
                var aData = oTable.fnGetData(nRow);
                var jqTds = $('>td', nRow);
                jqTds[0].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[0] + '">';
                jqTds[1].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[1] + '">';
                jqTds[2].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[2] + '">';
                jqTds[3].innerHTML = '<input type="text" class="form-control input-small" value="' + aData[3] + '">';
                jqTds[4].innerHTML = aData[4];
            }

            function saveRow(oTable, nRow) {
                var jqInputs = $('input', nRow);
                oTable.fnUpdate(jqInputs[0].value, nRow, 0, false);
                oTable.fnUpdate(jqInputs[1].value, nRow, 1, false);
                oTable.fnUpdate(jqInputs[2].value, nRow, 2, false);
                oTable.fnUpdate(jqInputs[3].value, nRow, 3, false);
                oTable.fnUpdate('<a href="#" class="btn btn-info btn-xs edit"><i class="fa fa-edit"></i> Edit</a> <a href="#" class="btn btn-danger btn-xs delete"><i class="fa fa-trash-o"></i> Delete</a>', nRow, 4, false);
                oTable.fnDraw();
            }

            function cancelEditRow(oTable, nRow) {
                var jqInputs = $('input', nRow);
                oTable.fnUpdate(jqInputs[0].value, nRow, 0, false);
                oTable.fnUpdate(jqInputs[1].value, nRow, 1, false);
                oTable.fnUpdate(jqInputs[2].value, nRow, 2, false);
                oTable.fnUpdate(jqInputs[3].value, nRow, 3, false);
                oTable.fnUpdate('<a href="#" class="btn btn-info btn-xs edit"><i class="fa fa-edit"></i> Edit</a> <a href="#" class="btn btn-danger btn-xs delete"><i class="fa fa-trash-o"></i> Delete</a>', nRow, 4, false);
                oTable.fnDraw();
            }
        }

    };
}();
var InitiateExpandableDataTable = function() {
    return {
        init: function() {
            /* Formatting function for row details */
            function fnFormatDetails(oTable, nTr) {
                var aData = oTable.fnGetData(nTr);
                var sOut = '<table>';
                sOut += '<tr><td rowspan="5" style="padding:0 10px 0 0;"><img src="assets/img/avatars/' + aData[6] + '"/></td><td>Name:</td><td>' + aData[1] + '</td></tr>';
                sOut += '<tr><td>Family:</td><td>' + aData[2] + '</td></tr>';
                sOut += '<tr><td>Age:</td><td>' + aData[3] + '</td></tr>';
                sOut += '<tr><td>Positon:</td><td>' + aData[4] + '</td></tr>';
                sOut += '<tr><td>Others:</td><td><a href="">Personal WebSite</a></td></tr>';
                sOut += '</table>';
                return sOut;
            }

            /*
             * Insert a 'details' column to the table
             */
            var nCloneTh = document.createElement('th');
            var nCloneTd = document.createElement('td');
            nCloneTd.innerHTML = '<i class="fa fa-plus-square-o row-details"></i>';

            $('#expandabledatatable thead tr').each(function() {
                this.insertBefore(nCloneTh, this.childNodes[0]);
            });

            $('#expandabledatatable tbody tr').each(function() {
                this.insertBefore(nCloneTd.cloneNode(true), this.childNodes[0]);
            });

            /*
             * Initialize DataTables, with no sorting on the 'details' column
             */
            var oTable = $('#expandabledatatable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
                "aoColumnDefs": [
                    { "bSortable": false, "aTargets": [0] },
                    { "bVisible": false, "aTargets": [6] }
                ],
                "aaSorting": [[0, 'All']],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 5,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });


            $('#expandabledatatable').on('click', ' tbody td .row-details', function() {
                var nTr = $(this).parents('tr')[0];
                if (oTable.fnIsOpen(nTr)) {
                    /* This row is already open - close it */
                    $(this).addClass("fa-plus-square-o").removeClass("fa-minus-square-o");
                    oTable.fnClose(nTr);
                } else {
                    /* Open this row */
                    $(this).addClass("fa-minus-square-o").removeClass("fa-plus-square-o");;
                    oTable.fnOpen(nTr, fnFormatDetails(oTable, nTr), 'details');
                }
            });

            $('#expandabledatatable_column_toggler input[type="checkbox"]').change(function() {
                var iCol = parseInt($(this).attr("data-column"));
                var bVis = oTable.fnSettings().aoColumns[iCol].bVisible;
                oTable.fnSetColumnVis(iCol, (bVis ? false : true));
            });

            $('body').on('click', '.dropdown-menu.hold-on-click', function(e) {
                e.stopPropagation();
            });
        }
    };
}();
var InitiateSearchableDataTable = function() {
    return {
        init: function() {
            var oTable = $('#searchable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[1, 'asc']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false },
							{ "bSortable": false },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                },
				"responsive": {
					"details": "true"
				},
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();

var InitiateLivecardstableDataTable = function() {
    return {
        init: function() {
            var oTable = $('#livecardstable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"ifp<"clear">>rt<"bottom"ip<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false },
							{ "bSortable": false },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
				"oTableTools": {
					"aButtons": [
					{
						"sExtends":    "xls",
						"sButtonText": 'Download',
					}
				]
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                },
				"abuttons": [
					{
						"text": 'My button',
						"action": function ( e, dt, node, config ) {
							alert( 'Button activated' );
						}
					}
				]
            });
			
            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			/* Formatting function for row details */
            function fnFormatDetails(oTable, nTr) {
                var aData = oTable.fnGetData(nTr);
                var sOut = '<table>';
                sOut += '<tr><td>Card Number:</td><td>' + aData[0] + '</td></tr>';
                sOut += '<tr><td>Account Number:</td><td>' + aData[1] + '</td></tr>';
                sOut += '<tr><td>Purchase Option:</td><td> Esso </td></tr>';
                sOut += '<tr><td>Issued:</td><td> 12/02/2016 12:17:36 </td></tr>';
                sOut += '<tr><td>Expires:</td><td> 	28/02/2018 00:00:00 </td></tr>';
                sOut += '<tr><td>Last Used:</td><td> 01/01/0001 00:00:00 </td></tr>';
                sOut += '<tr><td>Account Manager:</td><td>  </td></tr>';
                sOut += '<tr><td>Name on Card:</td><td>  </td></tr>';
                sOut += '<tr><td>Registration:</td><td>' + aData[3] + '</td></tr>';
                sOut += '</table>';
                return sOut;
            }
		
			$('#livecardstable').on('click', ' tbody td span.view-details', function() {
                var nTr = $(this).parents('tr')[0];
                if (oTable.fnIsOpen(nTr)) {
                    /* This row is already open - close it */
                    //$(this).addClass("fa-plus-square-o").removeClass("fa-minus-square-o");
                    oTable.fnClose(nTr);
                } else {
                    /* Open this row */
                    //$(this).addClass("fa-minus-square-o").removeClass("fa-plus-square-o");;
                    oTable.fnOpen(nTr, fnFormatDetails(oTable, nTr), 'details');
                }
            });
			$('#livecardstable').on('click', ' tbody td span.view-drawings', function() {
                var nTr = $(this).parents('tr')[0];
                if (oTable.fnIsOpen(nTr)) {
                    /* This row is already open - close it */
                    //$(this).addClass("fa-plus-square-o").removeClass("fa-minus-square-o");
                    oTable.fnClose(nTr);
                } else {
                    /* Open this row */
                    //$(this).addClass("fa-minus-square-o").removeClass("fa-plus-square-o");;
                    oTable.fnOpen(nTr, fnFormatDetails(oTable, nTr), 'details');
                }
            });
        }
    };
}();

var InitiateStopcardsDataTable = function() {
    return {
        init: function() {
            var oTable = $('#stopcardsdatatable').dataTable({
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#stopcardsdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#stopcardsdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#stopcardsdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateCardhistoryDataTable = function() {
    return {
        init: function() {
            var oTable = $('#cardhistorydatatable').dataTable({
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();

var InitiatePendingcardsdatatable = function() {
    return {
        init: function() {
            var oTable = $('#pendingcardsdatatable').dataTable({
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#pendingcardsdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#pendingcardsdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#pendingcardsdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateReduntantDataTable = function() {
    return {
        init: function() {
            var oTable = $('#reduntantdatatable').dataTable({
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }

            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#reduntantdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#reduntantdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#reduntantdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateSelectcardsDataTable = function() {
    return {
        init: function() {
            var oTable = $('#selectcardsdatatable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
                "aaSorting": [[0, 'all']],
				"searching": false,
				"bLengthChange": false,
				"bPaginate": false,
				"bFilter": false,
				"bInfo": false,
				"aButtons": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							]
            });
			
			//Check All Functionality
            $('#selectcardsdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#selectcardsdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#selectcardsdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateSelectedcardsDataTable = function() {
    return {
        init: function() {
            //Datatable Initiating
            var oTable = $('#selectedcardsdatatable').dataTable({
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"ifp<"clear">>rt<"bottom"ip<"clear">>',
				//"sdom": 'Bfrtip',
				"aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
                "iDisplayLength": 15,
                "oTableTools": {
					"aButtons": [
					{
						"sExtends":    "xls",
						"sButtonText": 'Download',
					},
					{
						"sExtends":    "text",
						"sButtonText": 'Email',
					}
				]
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

        }

    };

}();

var InitiateinvoicesDataTable = function() {
    return {
        init: function() {
            var oTable = $('#invoicesdatatable').dataTable({
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
					"aButtons": [
					{
						"sExtends":    "xls",
						"sButtonText": 'Download',
					}
				]
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#invoicesdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#invoicesdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#invoicesdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateStatementDataTable = function() {
    return {
        init: function() {
            var oTable = $('#statementdatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#statementdatatable thead th input[type=checkbox]').change(function() {
                var set = $("#statementdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#invoicesdatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateCertificateDataTable = function() {
    return {
        init: function() {
            var oTable = $('#certificatedatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });
			
			//Check All Functionality
            $('#certificatedatatable thead th input[type=checkbox]').change(function() {
                var set = $("#certificatedatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function() {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#certificatedatatable tbody tr input[type=checkbox]').change(function() {
                $(this).parents('tr').toggleClass("active");
            });
        }
    };
}();

var InitiateViewproductbpDataTable = function() {
    return {
        init: function() {
            var oTable = $('#viewproductbpdatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();
var InitiateViewproductessoDataTable = function() {
    return {
        init: function() {
            var oTable = $('#viewproductessodatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();
var InitiateViewproducttexacoDataTable = function() {
    return {
        init: function() {
            var oTable = $('#viewproducttexacodatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				//"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();
var InitiateViewproductshellDataTable = function() {
    return {
        init: function() {
            var oTable = $('#viewproductshelldatatable').dataTable({
				"sDom": '<"top"ip<"clear">>rt<"bottom"ip<"clear">>',
				"responsive": {
								"details": {
									"type": 'column'
								}
							},
							"columnDefs": [ {
								"className": 'control',
								"orderable": false,
								"targets":   0
							} ],
                "sDom": "Tflt<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
				"sDom": '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
                "aaSorting": [[0, 'all']],
				"bLengthChange": false,
				"bInfo": false,
				"aoColumns": [
							{ "bSortable": false },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": true },
							{ "bSortable": false }
							],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 15,
                "oTableTools": {
                    "aButtons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

            $("thead input").keyup(function() {
                /* Filter on the column (the index) of this element */
                oTable.fnFilter(this.value, $("thead input").index(this));
            });

        }
    };
}();



var InitiateExampleDataTable = function() {
    return {
        init: function() {
            /* Formatting function for row details */    
            /*
             * Initialize DataTables, with no sorting on the 'details' column
             */
            var oTable = $('#exampledatatable').dataTable({
                dom: '<"top"fipB<"clear">>rt<"bottom"ip<"clear">>',
                "aoColumnDefs": [
                    { "bSortable": false, "aTargets": [0] },
                    { "bVisible": false, "aTargets": [6] }
                ],
                "aaSorting": [[0, 'All']],
                "aLengthMenu": [
                    [5, 15, 20, -1],
                    [5, 15, 20, "All"]
                ],
                "iDisplayLength": 5,
                "oTableTools": {
                    "buttons": [
                        "copy",
                        "print",
                        {
                            "sExtends": "collection",
                            "sButtonText": "Save <i class=\"fa fa-angle-down\"></i>",
                            "aButtons": ["csv", "xls", "pdf"]
                        }
                    ],
                    "sSwfPath": "assets/swf/copy_csv_xls_pdf.swf"
                },
                "language": {
                    "search": "",
                    "sLengthMenu": "_MENU_",
                    "oPaginate": {
                        "sPrevious": "Prev",
                        "sNext": "Next"
                    }
                }
            });

        }
    };
}();




// WEBPACK FOOTER //
// src/assets/js/datatable/datatables-init.js